import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { NotificationService } from '../../shared/service/notification.service';
import { UtilityService } from "../../shared/common/utility.service";
import { LoaderService } from '../../shared/loader/loader.service';
import { DataService } from "../../shared/service/data.service";
import { ErrorService } from "../../shared/error/error.service";
import { SessionInfo } from "../../shared/session/SessionInfo";

import { IMenuParametro }  from "./header.model";

import { MatChipInputEvent } from '@angular/material';

@Injectable()
export class HeaderService {
	constructor(private dataService: DataService,
              private errorService: ErrorService,
              private notificationService: NotificationService,
              private loaderService: LoaderService,
              private utilityService: UtilityService,
              private sessionInfo: SessionInfo) { }
	listarMenuModulosUrl: string = 'seguridad/controles/ListarMenuUsuario';

	listarMenuParametros(menuParametro : IMenuParametro): any {

		let parameters: string;
		parameters = JSON.stringify({
      pAplicacionID : this.sessionInfo.getAplicacionID(),
      pRoleID : this.sessionInfo.getRoleID()
    });

		this.dataService.set(this.listarMenuModulosUrl);
		return this.dataService.execPostJson(parameters);
	}

}
